import { ActionDataI } from "./type";
import { IdGenerator } from "../IdGenerator/IdGenerator";

export class Action {
  public id: string = IdGenerator.generateId();
  public data: ActionDataI;

  public static fromJSON(json: ActionDataI): Action {
    return new Action(json);
  }

  public constructor(data: ActionDataI) {
    this.data = data;
  }

  public undo() {
    return this.data.before;
  }

  public redo() {
    return this.data.after;
  }

  public compare(action: Action): boolean {
    return this.id === action.id;
  }

  public toJSON(): ActionDataI {
    return this.data;
  }
}
